<template>
  <div class="otodetzyls">
    <div class="zylshed between">
      <div class="ti1">专业律师</div>
      <div class="mo1">更多</div>
    </div>
    <div class="zylsswiper">
      <el-carousel
        trigger="click"
        height="525px"
        indicator-position="outside"
        arrow="never"
      >
        <el-carousel-item v-for="item in 2" :key="item">
          <div class="zylsswiperitem">
            <div class="adv2lawitem flex_start" v-for="i in 4" :key="i + 'a'">
              <div class="adv2cov">
                <img src="../../../assets/case/aaaa1_sample.png" alt="" />
              </div>
              <div>
                <div class="adv2name">杨洋律师</div>
                <div class="adv2dh">
                  <svg-icon icon-class="dianhua" /> 135-1582-4555
                </div>
                <div class="adv2btn">咨询我</div>
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.otodetzyls {
  padding: 20px;
  .zylshed {
    .ti1 {
      font-size: 22px;
      color: #333;
    }
    .mo1 {
      cursor: pointer;
      font-size: 14px;
      color: #999999;
    }
  }
  .zylsswiper {
    ::v-deep .is-active .el-carousel__button {
      transform: scale(1.3);
    }
    ::v-deep .el-carousel__button {
      width: 10px;
      height: 10px;
      background: #999999;
      border-radius: 50%;
    }
    ::v-deep .el-carousel__indicators--horizontal {
      bottom: 20px;
    }
    .zylsswiperitem {
      height: 100%;
      .adv2lawitem {
        width: 240px;
        height: 110px;
        background: #f9f9fa;
        border-radius: 5px;
        margin-top: 20px;
        padding: 15px 10px;
        cursor: pointer;
        align-items: flex-start;
        .adv2cov {
          margin-right: 6px;
          img {
            width: 70px;
            height: 70px;
            border-radius: 50%;
          }
        }
        .adv2name {
          font-size: 16px;
          color: #333;
        }
        .adv2dh {
          margin-top: 5px;
          font-size: 14px;
          color: #999999;
        }
        .adv2btn {
          display: none;
          margin-top: 10px;
          width: 70px;
          height: 25px;
          text-align: center;
          line-height: 25px;
          background: #3689fb;
          border-radius: 20px;
          font-size: 14px;
          color: #ffffff;
        }

        &:hover {
          .adv2btn {
            display: block;
          }
        }
      }
    }
  }
}
</style>